export default "/assets/images/highway-pollution-video-thumbnail.ef114f705c4779bb.jpg";